/* This file was automatically generated - please modify the template not this file! */

/* eslint-disable quote-props */
import { ADMIN_ROLES } from "../../auth";

import { AppState } from "./model";
import { adminUserSelector } from "./selectors";
import { detailRoutes } from "./detailRoutes";

const detailRoute = () => ({
    "/:adminUserId": {
        title: (state: AppState) => adminUserSelector(state).emailAddress || "Admin User",
        "/edit": {
            title: "Edit",
        },
        ...detailRoutes
    }
});

export const routes = {
    "/adminUsers": {
        title: "Admin Users",
        ...detailRoute(),
        authorize: [ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/create": {
            title: "Create Admin User"
        }
    }
};
